import QuizResult from 'es6/models/quiz-result';

/**
 * These are the valid fields for extra QuizData.
 */
const VALID_QUIZ_DATA_FIELDS = [
  'choiceMade', 'choices', 'hintUsed', 'hintsUsed', 'enteredText', 'targetText',

  // Legacy purposes from behavior.js
  'entered_text', 'target_text',
];

/**
 * Base class for quizzes.
 */
export class QuizBase {
  constructor(contentDomain, contentId, goalId, isDiagnosticQuiz, quizFinishedCallback, quizTimer) {
    this._contentDomain = contentDomain;
    this._contentId = contentId;
    this._isDiagnosticQuiz = isDiagnosticQuiz;
    this._quizTimer = quizTimer;
    this._quizFinishedCallback = quizFinishedCallback;
    this._screenManager = Smartfm.screenManager;

    this.paused = false;
    this.result = new QuizResult(contentDomain, contentId, goalId);
  }

  /**
   * Returns the content ID being studied.
   *
   * @returns {Number}
   */
  getContentId() {
    return this._contentId;
  }

  /**
   * Returns the content domain for the quiz specializes in.
   *
   * @returns {String}
   */
  getContentDomain() {
    return this._contentDomain;
  }

  /**
   * Finalizes the quiz result and returns the presentation data.
   *
   * @returns {Object}
   */
  getFinalResult() {
    return this.result.finalize();
  }

  /**
   * Ends the quiz and triggers the end of quiz callback.
   */
  finishQuiz() {
    this.result.resume();
    this.result.endCurrentPhase();
    this._quizFinishedCallback(this);
  }

  /**
   * Pauses the quiz.
   */
  pause() {
    this.paused = true;

    if (this._quizTimer) {
      this._quizTimer.pause();
    }

    this.result.pause();
  }

  /**
   * Resumes the quiz.
   */
  resume() {
    this.paused = false;

    if (this._quizTimer) {
      this._quizTimer.resume();
    }

    this.result.resume();
  }

  /**
   * The show method needs to be defined and overriden.
   *
   * @override
   */
  show() {
    throw new Error('show() needs to be defined');
  }

  /**
   * Sets the quiz type for each result. Should be called by all
   * inheriting classes.
   *
   * @param {String} quizType
   */
  _setQuizType(quizType) {
    this.quizType = quizType;
    this.result.leQuizType = quizType;
  }

  /**
   * This will set the quiz data for the QuizResult. This function
   * will not completely replace all the data, but merely override
   * the fields provided.
   *
   * Reference the VALID_QUIZ_DATA_FIELDS constant above to see
   * which fields are acceptable to pass in.
   *
   * @param {Object} quizData
   */
  updateQuizData(quizData = {}) {
    const validFields = _.pick(quizData, ...VALID_QUIZ_DATA_FIELDS);
    Object.assign(this.result.quizData, validFields);
  }
}

export default QuizBase;
